import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { BuyerInsightsService } from './insights.service';

@Injectable({ providedIn: 'root' })
export class BuyerInsightsWorkingCapitalLiftGuard implements CanActivate {
    // Let's cache this and just call the API once per page load.
    private _canActivate?: boolean = undefined;

    constructor(private _insightsService: BuyerInsightsService, private _router: Router) {}

    public async canActivate(): Promise<boolean | UrlTree> {
        if (this._canActivate === undefined) {
            this._canActivate = await this._insightsService.workingCapitalLiftIsActivatedForBuyer();
        }

        return this._canActivate || this._router.parseUrl(`/${UiRoutes.NotFound}`);
    }
}
